import LocationLayout from './LocationLayout';
import { P, H2b, H3b } from '../content/Typography';
import { locations } from './locations';

const meta = locations.find((l) => l.slug === 'metal-fabrication-gta');

export default function GTA() {
  return (
    <LocationLayout title={meta.title} description={meta.description} heading={meta.heading}>
      <P>
        The Greater Toronto Area is not a single fabrication market — it is several distinct ones stitched together, each shaped by the industries that
        grew up around it. Knowing which part of the GTA specializes in what makes it much easier to find the right shop for a given part, rather than
        treating the region as one undifferentiated pool of fabricators.
      </P>

      <H2b>Regional strengths across the GTA</H2b>

      <H3b>Western GTA — precision CNC and aerospace</H3b>
      <P>
        Mississauga and Brampton anchor the western GTA's manufacturing base, built up around proximity to Pearson airport and the aerospace supply chain
        that follows it. Shops here lean toward precision CNC machining, tight tolerances, and documented material traceability — a good fit for parts
        where accuracy matters more than speed.
      </P>

      <H3b>Eastern GTA — heavy fabrication and automotive</H3b>
      <P>
        Scarborough and the Durham region to the east carry more of the GTA's heavy fabrication and automotive-adjacent supply chain work. Expect a higher
        concentration of shops comfortable with structural welding, larger assemblies, and production runs feeding into automotive manufacturing.
      </P>

      <H3b>Central Toronto — architectural and specialty metalwork</H3b>
      <P>
        Downtown and the surrounding core have a smaller but distinct base of shops focused on architectural metalwork and specialty fabrication — custom
        railings, retail fixtures, and hospitality equipment for the dense concentration of restaurants, offices, and commercial buildouts in the core.
      </P>

      <H3b>Markham and Richmond Hill — electronics enclosures</H3b>
      <P>
        North of the city, Markham and Richmond Hill have built up fabrication capacity around the tech and electronics companies concentrated in the area —
        precision sheet metal work well suited to enclosures, chassis, and mounting hardware for electronic products.
      </P>

      <H2b>One brief, matched to the right corner of the region</H2b>
      <P>
        Because the GTA's strengths are regional rather than uniform, the fastest path to a good quote is matching your part to the sub-region that actually
        specializes in it — not necessarily the shop closest to you. Submit a sketch or photo through MetalMatch and we route your brief to fabricators
        across the GTA based on what your part actually needs, whether that means a western-GTA precision shop, an eastern-GTA heavy fabricator, or a
        Markham electronics enclosure specialist.
      </P>
      <P>
        This is also why a single GTA-wide submission is often more useful than guessing at a specific city up front — if you are not sure whether your
        part needs a precision machinist or a structural welder, we can route it to the sub-region built for it once we understand what you are building.
      </P>
    </LocationLayout>
  );
}
